import React from 'react';
import PropTypes from 'prop-types';
import { PageLevelNotification } from '@americanexpress/dls-react';
import styles from './OfflineWarning.scss';

class OfflineWarning extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
      fetchIconFont: false,
    };
  }

  componentDidMount() {
    window.addEventListener('online', this.hideWarning);
    window.addEventListener('offline', this.showWarning);
    this.deferredRenderOfflineFontFetcher();
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.hideWarning);
    window.removeEventListener('offline', this.showWarning);
  }

  deferredRenderOfflineFontFetcher = () => {
    const callback = () => this.setState({ fetchIconFont: true });

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(callback);
    } else {
      setTimeout(callback, 10e6);
    }
    // eslint-disable-next-line @stylistic/semi -- class property arrow function
  }

  showWarning = () => this.setState({ hidden: false });

  hideWarning = () => this.setState({ hidden: true });

  render() {
    const offline = global.BROWSER && navigator.onLine === false;
    const { hidden, fetchIconFont } = this.state;
    const { languageData } = this.props;

    const message = languageData?.offlineWarning || 'You are not connected to the internet. Some experiences may not work as expected.';

    if (!offline || hidden) {
      return fetchIconFont
        ? <div className={`${styles.offlineFontFetcher}`} />
        : null;
    }

    return (
      <aside className={styles.offlineWarning}>
        <PageLevelNotification
          type="critical"
          isDismissible={true}
          aria-live="polite"
          headingSlot={(
            <p id="offlineWarning">
              {message}
            </p>
          )}
        />
      </aside>
    );
  }
}

OfflineWarning.propTypes = {
  languageData: PropTypes.objectOf(PropTypes.string),
};

export default OfflineWarning;
